import { Link } from "react-router-dom";
import { walletOfOwner } from "../utils/interact";
import React, { useState, useEffect } from "react";
import NFTs from "../_metadata.json";
import abi from "../abi.json";
import Web3 from "web3";
const { ethereum } = window;
const web3 = new Web3(ethereum);
const address = "0xFAc96E4e3201e6928C1a2d3E8bd6B8d5072C7648";
const chainID = 1;
let network;

function Withdraw() {
  const [balance, setBalance] = useState("");
  const [status, setStatus] = useState("Withdraw Balance");

  useEffect(async () => {
    if (window.ethereum) {
      const contract = new web3.eth.Contract(abi, address);
      const accounts = await web3.eth.getAccounts();
      await web3.eth.net.getId().then(async (netId) => {
        if (netId != chainID) {
          return {
            status: "👆🏽 Please connect to ETC Network.",
          };
        } else {
          try {
            const token = await contract.methods.balanceOf(address).call({
              from: accounts[0],
            });
            console.log(token);
            setBalance(Web3.utils.fromWei(token, "ether"));
          } catch (error) {
            console.log(error);
            return {
              success: false,
              status: "😥 Something went wrong: " + error.message,
            };
          }
        }
      });
    } else {
      return {
        address: "",
        status: (
          <span>
            <p>
              {" "}
              🦊{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://metamask.io/download.html`}
              >
                You must install Metamask, a virtual Ethereum wallet, in your
                browser.
              </a>
            </p>
          </span>
        ),
      };
    }
  }, []);

  const getFund = async () => {
    setStatus("Loading");
    if (window.ethereum) {
      const contract = new web3.eth.Contract(abi, address);
      const accounts = await web3.eth.getAccounts();

      try {
        const token = await contract.methods.withdraw().call({
          from: accounts[0],
        });
        console.log(token);
        return token;
      } catch (error) {
        return {
          success: false,
          status: "😥 Something went wrong: " + error.message,
        };
      }
    } else {
      return {
        address: "",
        status: (
          <span>
            <p>
              {" "}
              🦊{" "}
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://metamask.io/download.html`}
              >
                You must install Metamask, a virtual Ethereum wallet, in your
                browser.
              </a>
            </p>
          </span>
        ),
      };
    }
  };

  return (
    <section
      className="container project_container"
      id="nftproject"
      style={{
        marginTop: "11rem",
      }}
    >
      <h2>Withdraw</h2>

      {/* <p>Balance: {balance} ETC</p> */}
      <button
        style={{
          padding: "23px",
          background: "#ff776e",
          color: "#fff",
          borderRadius: "27px",
          width: "100%",
        }}
        onClick={() => getFund()}
      >
        {status}
      </button>
    </section>
  );
}

export default Withdraw;
